import {Preloader} from "../preloader/preloader";
import {Tabs} from "../tabs/tabs";
import {Delivery} from "../delivery/delivery";

class Map
{

    constructor(elem)
    {
        this.map = elem;
        this.mapDelivery = this.map.closest('[data-delivery]');
        this.mapDeliveryTab = this.mapDelivery.closest('[data-tabs]').find('[data-map-tab]');
        this.list = this.mapDelivery.find('[data-delivery-list]');
        this.emptyList = this.mapDelivery.find('[data-delivery-list-empty]');
        this.shopsButton = this.list.closest('[data-tabs]').find('[data-map-button]');
        this.pointsList = this.map.find('[data-point-list]');

        this.deliveryLink = $('[data-delivery-link]');
        this.searchCityForm = $('[data-delivery-search-form]');
        this.searchCity = this.searchCityForm.find('[data-delivery-city-search]');
        this.searchCityBtn = $('[data-delivery-city-search-btn]');
        this.getLocationElem = this.mapDelivery.find('[data-delivery-location]');
        this.search = this.mapDelivery.find('[data-delivery-search]');
        this.select = this.mapDelivery.find('[data-delivery-select]');
        this.tableCourier = $('[data-delivery-courier]');
        this.tableOptions = $('[data-delivery-options]');
        this.tableDelivery = this.map.closest('[data-tabs]');
        this.ajaxContainer = this.map.closest('[data-ajax-container]');
        this.category = this.mapDelivery.find('[data-delivery-category]');
        this.categoryName = $('[data-delivery-category-name]');
        this.geoObjectsInit = [];
        this.clusterer;
        this.maps;
        this.isCity = window.city || '';
        this.cityCoords = '';
        this.isSearch = '';
        this.isSelect = '';
        this.template = '';
        this.templateСourier = '';
        this.templateOptions = '';
        this.courier = window.courier;
        this.courierCity = [];
        this.res = [];
        this.path = '/';
        this.currentPoint = null;
    }

    initialize()
    {
        let shops = window.shops;
        const that = this;

        $(document).ready(() => {
            if (typeof ymaps != 'undefined') {
                ymaps.ready(() => {
                    this.map.each((index, el) => {
                        let load = $(el).data('map');
                        let status = false;

                        if (load == '') status = true;

                        this.loadMap($(el), status, 'init', shops);
                        // this.getUserLocation();
                    });
                });
            }
        });

        if (process.env.NODE_ENV != 'development') {
            this.path = '/local/frontend/build/'
        }
    }

    loadMap(el, status, func, shops)
    {
        if (status) {
            if (func == 'init') {
                if (el.children().length < 1) {
                    this.init(el.attr('id'), shops);
                }
            }
        }
    }

    init(id, shops)
    {
        const that = this;
        let preloader;

        if (this.searchCity.length > 0) {
            this.searchCity.off().on('input', (e) => {
                if (this.searchCity.val().length > 1) {
                    this.isCity = this.searchCity.val().trim();
                }
                this.findCityAjax(e.target);
            });

            // if (this.searchCity.val().length > 2) {
            // this.isCity = this.searchCity.val().trim();
            //
            // this.sortShopsList(this.isCity, this.isSearch, this.isSelect, shops);
            //
            // if (this.tableCourier.length) {
            //   this.courierCity = this.sortСourierList(this.isCity, this.courier);
            // }
            // }
        }

        this.searchCityBtn.on('click', (e) => {
            let el = e.target.parentElement.previousElementSibling;

            // this.findCityAjax(el);

            e.preventDefault();
        })

        this.searchCityForm.off().on('keydown', function(e) {
            if ((e.key === 'Enter' || e.keyCode === 13) && that.map.is('[data-map-delivery]')) {
                console.log('cancel');
                return false
            }
        });

        this.searchCityForm.off().on('submit', function(e) {
            let input = $(this).find('[data-delivery-city-search]')
            let selectValue = input.val();
            $('[data-delivery-city-search]').val(selectValue)
            if (selectValue.length > 1) {
                that.isCity = selectValue.trim();

                ymaps.geocode(that.isCity).then((result) => {
                    that.cityCoords = result.geoObjects.get(0).geometry.getCoordinates();
                    let location = result.geoObjects.get(0).geometry.getCoordinates();
                    let locationCheck = new ymaps.Circle([location, 100000], {}, {
                        geodestic: true,
                        opacity: 0,
                    })

                    that.maps.geoObjects.add(locationCheck);

                    let newArray = [];

                    shops.forEach((item) => {
                        if (locationCheck.geometry.contains(item.coords.split(','))) {
                            newArray.push(item);
                        }
                    })

                    that.isCity = newArray[0] === undefined ? '' : newArray[0].city
                    that.maps.geoObjects.remove(locationCheck);

                    that.isSearch = selectValue;
                    that.sortShopsList(that.isCity, that.isSearch, that.isSelect, newArray);
                    if (that.tableCourier.length) {
                        that.courierCity = that.sortСourierList(that.isCity, that.courier);
                    }

                    that.searchCity.removeClass('active')

                    if (that.mapDelivery.closest('[data-tabs]').length > 0 && that.res.length === 0) {
                        that.mapDeliveryTab.addClass('disabled');
                        let headTabs = that.mapDelivery.closest('[data-tabs]').find('[data-tabs-head]');
                        $(headTabs).children()[0].click();
                    } else if (that.mapDelivery.closest('[data-tabs]').length > 0 && that.res.length > 0) {
                        that.mapDeliveryTab.removeClass('disabled');
                    }
                })
            } else {
                that.isCity = '';
                that.isSearch = '';
                that.sortShopsList(that.isCity, that.isSearch, tthat.isSelect, shops);
                if (that.tableCourier.length) {
                    that.courierCity = that.sortСourierList(that.isCity, that.courier);
                }

                that.searchCity.removeClass('active')
            }

            e.preventDefault();
        });

        $(document).off('click', '[data-location-delivery]');
        $(document).on('click', '[data-location-delivery]', function(e) {
            let el = $(this);
            let location = el.attr('data-location-delivery');
            let locationId = el.attr('data-id');
            if ($('[data-preloader]').length > 0) {
                $('[data-preloader]').show();
            }


            if (window.xhr_save_city && window.xhr_save_city.readyState != 4) {
                window.xhr_save_city.abort();
            }
            window.xhr_save_city = $.post(window.langUrl + '/local/ajax/delivery.php', {
                city: location,
                cityId: locationId,
                sessid: that.searchCityForm.find('input[name="sessid"]').val()
            }).done(function(data) {
                that.searchCity.val(location);
                if (that.ajaxContainer.length > 0) {
                    that.ajaxContainer.html(data);
                } else {
                    that.tableDelivery.html(data);
                }
                that.searchCityForm.find('[data-delivery-city-res]').hide();
                // that.searchCityForm.submit();
                window.city = location;

                let tabs = [];

                if ($('[data-tabs-head]').length > 0) {
                    $('[data-tabs-head]').each(function(i) {
                        tabs[i] = new Tabs($(this));
                        tabs[i].initialize();
                    });
                }

                let map = [];
                if ($('[data-map]').length > 0) {
                    $('[data-map]').each(function(i) {
                        map[i] = new Map($(this));
                        map[i].initialize();
                    });
                }

                let delivery = [];

                if ($('[data-delivery]').length > 0) {
                    $('[data-delivery]').each(function(i) {
                        delivery[i] = new Delivery($(this));
                        delivery[i].initialize();
                    });
                }

                let lazy = new LazyLoad(document.querySelectorAll('img.lazyload'));
                lazy.loadImages();

                if ($('[data-preloader]').length > 0) {
                    $('[data-preloader]').hide();
                }
            });
            e.preventDefault();
        });

        if (!shops.length) {
            return false;
        }

        let centerLat = 0;
        let centerLon = 0;

        if (this.isCity == '') {
            this.isCity = $('[data-user-city]').eq(0).text()
        }

        if ($('[data-preloader]').length > 0) {
            $('[data-preloader]').each(function(i) {
                preloader = new Preloader($(this));
            })
        }
        this.tableCourier.append('<tbody class="table__tbody"></tbody>');

        for (let i = 0; i < shops.length; i++) {
            centerLat += parseFloat(shops[i].coords.split(',')[0]);
            centerLon += parseFloat(shops[i].coords.split(',')[1]);
        }

        this.maps = new ymaps.Map(id, {
            center: [
                parseFloat(centerLat / shops.length),
                parseFloat(centerLon / shops.length)
            ],
            zoom: 11,
            controls: []
        }, {
            searchControlProvider: 'yandex#search',
            yandexMapDisablePoiInteractivity: true
        });

        // if (this.map.is('[data-map-delivery]')) {
        ymaps.geocode(that.isCity).then((res) => {
            that.searchCity.val(that.isCity);
            that.cityCoords = res.geoObjects.get(0).geometry.getCoordinates();
            that.sortShopsList(that.isCity, that.isSearch, that.isSelect, shops);
            // that.maps.setCenter(res.geoObjects.get(0).geometry._coordinates,10, {
            //   checkZoomRange: false,
            //   duration: 1000,
            //   timingFunction: 'ease'
            // });
        });
        // }

        if (!this.map.is('[data-map-delivery]')) {
            // Добавим элемент управления с собственной меткой геолокации на карте.
            let geolocationControl = new ymaps.control.GeolocationControl({
                options: {noPlacemark: true}
            });

            geolocationControl.events.add('locationchange', function(event) {
                let position = event.get('position');
                // Установим новый центр карты в текущее местоположение пользователя.
                that.maps.panTo(position);

                let geolocation = ymaps.geolocation
                geolocation.get({
                    provider: '213.110.97.151',
                    mapStateAutoApply: true
                }).then(function(result) {
                    that.isCity = result.geoObjects.get(0).getLocalities()[0];
                    that.searchCity.val(that.isCity);
                    that.isSearch = that.isCity;
                    $('[data-user-city]').text(that.isCity)
                    that.cityCoords = result.geoObjects.get(0).geometry.getCoordinates();

                    setTimeout(() => {
                        that.sortShopsList(that.isCity, that.isSearch, that.isSelect, shops);

                        if (that.mapDelivery.closest('[data-tabs]').length > 0 && that.res.length === 0) {
                            that.mapDeliveryTab.addClass('disabled');
                            let headTabs = that.mapDelivery.closest('[data-tabs]').find('[data-tabs-head]');
                            $(headTabs).children()[0].click();
                        } else if (that.mapDelivery.closest('[data-tabs]').length > 0 && that.res.length > 0) {
                            that.mapDeliveryTab.removeClass('disabled');
                        }
                    }, 300);
                })
            });

            that.maps.controls.add(geolocationControl);
        }

        this.mapDeliveryTab.on('click', function() {
            ymaps.geocode(that.isCity).then((res) => {
                that.searchCity.val(that.isCity);
                that.cityCoords = res.geoObjects.get(0).geometry.getCoordinates();
                // that.sortShopsList(that.isCity, that.isSearch, that.isSelect, shops);
                let centerLat = 0;
                let centerLon = 0;
                let listLat = [];
                let listLng = [];

                for (let i = 0; i < that.res.length; i++) {
                    centerLat += parseFloat(that.res[i].coords.split(',')[0]);
                    centerLon += parseFloat(that.res[i].coords.split(',')[1]);
                    listLat.push(that.res[i].coords.split(',')[0]);
                    listLng.push(that.res[i].coords.split(',')[1]);
                }


                let centerAndZoom = ymaps.util.requireCenterAndZoom(
                    that.maps.getType(),
                    [
                        [Math.min(...listLat), Math.min(...listLng)], // Задаём минимальные и максимальные координаты объектов коллекции (городов)
                        [Math.max(...listLat), Math.max(...listLng)]
                    ],
                    that.maps.container.getSize()
                ).then(function(result) {
                    that.maps.setCenter(result.center, result.zoom, {
                        checkZoomRange: false,
                        duration: 1000,
                        timingFunction: 'ease'
                    });

                }, function(error) {

                    let coords = [
                        parseFloat(centerLat / that.res.length),
                        parseFloat(centerLon / that.res.length)
                    ]

                    that.maps.setCenter(coords, 8, {
                        checkZoomRange: false,
                        duration: 1000,
                        timingFunction: 'ease'
                    });
                });
            })
        });

        // Кастомный кластер
        let clusterIcons = [{
            href: '',
            size: [48, 48],
            offset: [-24, -24]
        }];

        let MyIconContentLayout = ymaps.templateLayoutFactory.createClass(
            '<div class="map-balloon-item map-balloon__cluster"><span class="map-balloon__cluster-amount">$[properties.geoObjects.length]</span></div>');

        let MyIconContentLayoutHover = ymaps.templateLayoutFactory.createClass(
            '<div class="map-balloon-item map-balloon__cluster map-balloon__cluster--hover"><span class="map-balloon__cluster-amount">$[properties.geoObjects.length]</span></div>');

        this.clusterer = new ymaps.Clusterer({
            clusterIcons: clusterIcons,
            clusterIconContentLayout: MyIconContentLayout
        });

        // Ховер на кластер
        this.clusterer.events
            .add('mouseenter', function(e) {
                e.get('target').options.set({clusterIconContentLayout: MyIconContentLayoutHover});
            })
            .add('mouseleave', function(e) {
                e.get('target').options.set({clusterIconContentLayout: MyIconContentLayout});
            });

        this.addPlacemark(shops);

        //  Спозиционируем карту так, чтобы на ней были видны все объекты
        this.maps.setBounds(this.clusterer.getBounds(), {
            checkZoomRange: false
        });

        // let idCity = this.searchCity.attr('id');
        // let suggestView = new ymaps.SuggestView(idCity);

        // suggestView.events.add('select', (e) => {
        //   let selectValue = e.get('item').value.split(', ');
        //   let last = selectValue.length - 1;

        //   selectValue = selectValue[last].trim();

        //   if (selectValue.length > 0) {
        //     this.isCity = selectValue;
        //   } else {
        //     this.isCity = '';
        //   }

        //   this.sortShopsList(this.isCity, this.isSearch, this.isSelect, shops);
        // });

        this.deliveryLink.on('click', function() {
            if (!that.cityCoords) {
                ymaps.geocode(that.isCity).then((res) => {
                    that.searchCity.val(that.isCity);
                    that.cityCoords = res.geoObjects.get(0).geometry.getCoordinates();
                });
            } else {
                that.zoomToShops();
            }
        });

        // this.search.on('keyup', (e) => {
        //   let value = e.target.value;

        //   if (value.length > 2) {
        //     this.isSearch = value;
        //   } else {
        //     this.isSearch = '';
        //   }

        //   this.isCity = this.isSearch

        //   this.sortShopsList(this.isCity, this.isSearch, this.isSelect, shops);
        // });

        this.shopsButton.on('click', function() {
            if (!!that.point) {
                let parentElem = that.point.closest('[data-tabs-body]');
                let scroll = that.point.offset().top - parentElem.offset().top + parentElem.scrollTop();
                that.point.addClass('open');
                parentElem.animate({scrollTop: scroll}, 1000);
            }
        });

        $(document).on('click', '[delivery-place]', function() {
            let el = $(this);
            let id = el.attr('data-id');
            let coords = el.attr('data-coords').split(',');
            // let zoom = that.maps.getZoom() > 12 ? that.maps.getZoom() : 12;
            let zoom = 17;

            that.maps.setCenter([coords[0], coords[1]], zoom, {
                checkZoomRange: false,
                duration: 1000,
                timingFunction: 'ease'
            });

            // let list = el.closest('[data-tabs-body]');
            // let scroll = el.offset().top - list.offset().top + list.scrollTop();
            // list.animate({scrollTop: scroll}, 1000);

            setTimeout(() => {
                for (let i = 0; i < that.res.length; i++) {
                    if (that.res[i].id == id) {
                        that.geoObjectsInit[i].balloon.open();
                    }
                }
            }, 1000);
        });

        this.select.on('change', (e) => {
            let value = e.target.value;
            this.isSelect = value;

            this.sortShopsList(this.isCity, this.isSearch, this.isSelect, shops);

            that.categoryName.text(that.isSelect || that.categoryName.attr('data-delivery-category-name'));
        });

        /**
         * Обработчик реализует переключение категорий магазинов «Официальные»/«Партнёры»
         */
        this.category.on('click', function(e) {
            let el = $(this);
            that.isSelect = el.attr('data-delivery-category');
            // let curShops = that.res.length === 0 ? shops : that.res

            // that.sortShopsList(that.isCity, that.isSearch, that.isSelect, curShops);
            that.sortShopsList(that.isCity, '', that.isSelect, shops);

            el.parent().children().removeClass('active');
            el.addClass('active')

            that.categoryName.text(that.isSelect || that.categoryName.attr('data-delivery-category-name'));

            e.preventDefault()
        });

        this.getLocationElem.click(() => {
            this.getUserLocation();
        });

        $(document).on('click', '[data-adress-choose]', function(e) {
            let el = $(this);
            let street = el.attr('data-adress-choose');
            let code = el.attr('data-code');

            let city = $('[data-header]').find('[data-user-city]').text();

            let delivery = $('#ORDER_FORM').find('input[name="DELIVERY_ID"]:checked').attr('data-order-delivery');

            $.magnificPopup.open({
                items: {
                    src: '#popup-order-adress'
                },
                type: 'inline',
                midClick: true,
                closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
                removalDelay: 500, //delay removal by X to allow out-animation
                callbacks: {
                    beforeOpen: function() {
                        this.st.mainClass = 'mfp-zoom-in mfp-modal';
                    },
                    open: function() {
                        $('#popup-order-adress').find('[data-address-order]').text(`${delivery} по адресу: г. ${city}, ${street}`)
                        $('#popup-order-adress').find('[data-order-adress-set]').attr('data-code', code)
                        $('#popup-order-adress').find('[data-order-adress-set]').attr('data-street', street)
                    }
                }
            });

            e.preventDefault();
        });
    }

    findCityAjax(el)
    {
        let value = el.value;
        let method = this.searchCityForm.attr('method') || "GET";
        let requestData = this.searchCityForm.serialize();

        let url = el.dataset.ajaxUrl;
        if (!url) {
            url = this.searchCityForm.attr('action');
        }

        if (this.searchCity.val().length > 1 && !!url) {

            if ($('[data-preloader]').length > 0) {
                $('[data-preloader]').show();
            }
            this.searchCity.addClass('active')
            if (window.xhr_search_city && window.xhr_search_city.readyState != 4) {
                window.xhr_search_city.abort();
            }
            window.xhr_search_city = $.ajax({
                url: url,
                method: method,
                dataType: 'json',
                data: requestData,
                // beforeSend: function (response) {
                //   preloader.setPreloader();
                // },
                // complete: function(response, text) {
                //   preloader.removePreloader();
                // }
            }).done((response) => {

                if ($('[data-preloader]').length > 0) {
                    $('[data-preloader]').hide();
                }
                this.findCity(response, value, this.searchCityForm);
                this.searchCityForm.find('[data-delivery-city-res]').show();
            }).fail(() => {
                if ($('[data-preloader]').length > 0) {
                    $('[data-preloader]').hide();
                }
                //if (process.env.NODE_ENV === 'development') {
                // this.findCity(arReturn, value, parent);
                //}
            });
        }
    }

    // поиск города в массиве
    findCity(response, val, parent)
    {
        let cities = response['data']['ITEMS']
        let list = parent.find('[data-delivery-city-res]');
        let total = 0;
        list.html('');

        for (let i = 0; i < cities.length; i++) {
            let value = cities[i]['VALUE'];

            if (value) {
                let loc = cities[i]['DISPLAY'];
                if (cities[i]['PATH_NAME'][0] != "" && typeof cities[i]['PATH_NAME'][0] != "undefined") {
                    loc = loc + '. ' + cities[i]['PATH_NAME'][0] + '.';
                }

                let template = `<a href="#" class="input__search-link" data-id="${cities[i]['VALUE']}" data-location-delivery="${cities[i]['DISPLAY']}">${loc}</a>`;
                list.append(template);
                total++;
            }
        }

        if (total == 0) {
            list.append('<div>По Вашему запросу ничего не найдено</div>');
        }
    }

    addPlacemark(shops)
    {
        const that = this;
        let BalloonContentLayoutClass = [];
        let pathAssent = '';

        this.geoObjectsInit = [];
        this.list.empty();

        let getPointOptions = () => {
            // mark
            return {
                iconLayout: 'default#image',
                iconImageHref: `${this.path}assets/images/required/map-marker.svg`,
                iconImageSize: [26, 26],
                iconImageOffset: [-13, -13],
                hideIconOnBalloonOpen: false,
                balloonPanelMaxMapArea: 0,
                balloonMaxWidth: 248,
                balloonMinWidth: 248,
                balloonOffset: [-65, -60]
            };
        };

        let getPointData = function(shop) {
            return {
                clusterCaption: `<div>${shop.title}</div>`,
                balloonContentBody: `
            <div>${shop.adress}</div>
            <br><br>
            <div>${shop.desc}</div>
        `
            };
        }

        for (let i = 0; i < shops.length; i++) {
            let pointData = '';
            let pointOptions = getPointOptions();
            let id = shops[i].id;
            let templateBallon = '';
            let shopCoordinates = [shops[i].coords.split(',')[0], shops[i].coords.split(',')[1]];

            pointOptions.iconImageHref = `${this.path}assets/images/required/map-marker.svg`;

            if (this.map.is('[data-map-cart]')) {
                templateBallon = `<div class="map-balloon">
          <div class= "map-balloon__inner" >
            <h3 class="map-balloon__title">${shops[i].title}</h3>
            <div class="map-balloon__desc mb-3"><p>${shops[i].adress}<br><br>${this.getSchedule({workday: shops[i].schedule_workday, dayoff: shops[i].schedule_dayoff})}</p></div>
            <div class="map-balloon__btn">
              <a href="#" class="btn btn--sm btn--min-sm btn--full" data-adress-choose="${shops[i].adress}" data-code="${shops[i].code}">Выбрать</a>
            </div>
          </div>
        </div>`;
            } else {
                templateBallon = `<div class="map-balloon">
          <div class= "map-balloon__inner" >
            <h3 class="map-balloon__title">${shops[i].title}</h3>
            <div class="map-balloon__desc mb-3"><p>${shops[i].adress}<br><br>${this.getSchedule({workday: shops[i].schedule_workday, dayoff: shops[i].schedule_dayoff})}</p><a href="tel:${shops[i].tel}">${shops[i].tel}</a></div>
          </div>
        </div>`;
            }

            BalloonContentLayoutClass[i] = ymaps.templateLayoutFactory.createClass(templateBallon);

            pointOptions.balloonContentLayout = BalloonContentLayoutClass[i],
                pointOptions.id = id;

            let mark = new ymaps.Placemark(shopCoordinates, getPointData(shops[i]), pointOptions);

            // наведение на пины
            mark.events
                .add('mouseenter', (e) => {
                    this.setIconPin(e, 'active');
                })
                .add('mouseleave', (e) => {
                    this.setIconPin(e);
                });

            // пины при открытии балуна
            mark.events.add('balloonopen', (e) => {
                let object = e.get('target');

                object.options.set({
                    iconImageHref: `${this.path}assets/images/required/map-marker-selected.svg`,
                    iconImageSize: [40, 60],
                    iconImageOffset: [-20, -60],
                });

                object.options.set({selected: true})

                let point = this.list.find(`[data-id="${object.options.get('id')}"]`);

                if (point.length) {
                    let parentElem = point.closest('[data-point-list]');
                    let scroll = point.offset().top - parentElem.offset().top + parentElem.scrollTop();
                    point.addClass('open');
                    this.point = point;
                    // $('[data-delivery-list]').animate({scrollTop : pointTop + 'px'}, 500);

                    parentElem.animate({scrollTop: scroll}, 1000);
                }
            });

            // закрытие балуна
            mark.events.add('balloonclose', (e) => {
                let object = e.get('target');

                object.options.set({
                    iconImageHref: `${this.path}assets/images/required/map-marker.svg`,
                    iconImageSize: [26, 26],
                    iconImageOffset: [-13, -13]
                });

                object.options.set({selected: false})
                this.list.find(`[data-id="${object.options.get('id')}"]`).removeClass('open');

                this.setIconPin(e);
            });

            this.geoObjectsInit.push(mark);
            this.clusterer.removeAll();

            this.clusterer.add(this.geoObjectsInit)
            this.maps.geoObjects.add(this.clusterer);

            let shopStatus = this.shopStatus({workday: shops[i].schedule_workday, dayoff: shops[i].schedule_dayoff, timezone: shops[i].timeZone})

            if (process.env.NODE_ENV === 'development') {
                pathAssent = '/'
            } else {
                pathAssent = '/local/frontend/build/'
            }
            this.template = `
      <div class="delivery-place" delivery-place data-id="${shops[i].id}" data-coords="${shops[i].coords}">
        <div class="delivery-place__info">
          <div class="delivery-place__title">${shops[i].title}</div>
          <div class="delivery-place__img"><img class="lazyload " src="${pathAssent}assets/images/${shops[i].img}" alt="" width="1" height="1" data-src="${pathAssent}assets/images/${shops[i].img}">
          </div>
          <div class="delivery-place__schedule mb-2">${this.getSchedule({workday: shops[i].schedule_workday, dayoff: shops[i].schedule_dayoff})}</div>
          <div class="delivery-place__adress">${shops[i].adress}</div>
          <div class="delivery-place__tel">${shops[i].tel}</div>
        </div>
        <div class="delivery-place__detail">
          <div class="delivery-place__status ${shopStatus.class}" data-delivery-status="">${shopStatus.text}</div>
          <div class="delivery-place__buttons">
            <a target="_blank" href="//maps.yandex.ru/?ll=${shops[i].coords.split(',').reverse().join(',')}&text=New%20Balance&z=19" class="delivery-place__buttons-item">
              <svg width="30" height="30" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M32.5 14.375H27.5C27.3674 14.375 27.2402 14.431 27.1465 14.5306C27.0527 14.6302 27 14.7654 27 14.9062C27 15.0471 27.0527 15.1823 27.1465 15.2819C27.2402 15.3815 27.3674 15.4375 27.5 15.4375H31.35C28.2758 17.0685 25.899 19.8786 24.7 23.3C24.419 22.1048 23.909 20.9841 23.2018 20.0078C22.4946 19.0316 21.6055 18.2208 20.59 17.6263L18.74 16.5638C18.6819 16.5251 18.617 16.4996 18.5492 16.4888C18.4814 16.4779 18.4122 16.482 18.346 16.5008C18.2798 16.5195 18.2179 16.5526 18.1641 16.5978C18.1104 16.6431 18.066 16.6996 18.0338 16.7638C18.0015 16.8281 17.9819 16.8987 17.9764 16.9713C17.9709 17.0439 17.9795 17.1169 18.0016 17.1858C18.0238 17.2547 18.0591 17.3181 18.1052 17.3719C18.1514 17.4258 18.2075 17.4689 18.27 17.4987L20.12 18.5612C21.32 19.2817 22.3142 20.3336 22.9972 21.6056C23.6803 22.8775 24.0268 24.3221 24 25.7863V35.0938C24 35.2346 24.0527 35.3698 24.1465 35.4694C24.2402 35.569 24.3674 35.625 24.5 35.625C24.6326 35.625 24.7598 35.569 24.8536 35.4694C24.9474 35.3698 25 35.2346 25 35.0938V27.55C25.0563 25.163 25.7423 22.8408 26.9798 20.8478C28.2174 18.8548 29.9568 17.271 32 16.2769V20.2188C32 20.3596 32.0527 20.4948 32.1465 20.5944C32.2402 20.694 32.3674 20.75 32.5 20.75C32.6326 20.75 32.7598 20.694 32.8536 20.5944C32.9474 20.4948 33 20.3596 33 20.2188V15.4375V14.9062C33 14.7654 32.9474 14.6302 32.8536 14.5306C32.7598 14.431 32.6326 14.375 32.5 14.375Z" fill="currentColor"/>
                <circle cx="25" cy="25" r="24.5" stroke="currentColor"/>
              </svg>
            </a>
            <a href="tel:+${shops[i].tel.replace(/\D/g, '').replace(/^1/, '')}" class="delivery-place__buttons-item">
              <svg width="30" height="30" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M33.74 29.4L29.53 27.3C29.3702 27.2255 29.1935 27.1946 29.0179 27.2104C28.8422 27.2262 28.6739 27.2881 28.53 27.39L26.27 29.08C26.0941 29.2119 25.8798 29.2822 25.66 29.28C25.4805 29.2799 25.3043 29.2316 25.15 29.14C23.0094 27.8222 21.2078 26.0206 19.89 23.88C19.7869 23.7087 19.7375 23.5104 19.7482 23.3108C19.7589 23.1111 19.8292 22.9193 19.95 22.76L21.64 20.5C21.7418 20.356 21.8038 20.1877 21.8196 20.0121C21.8354 19.8365 21.8045 19.6598 21.73 19.5L19.6 15.26C19.5291 15.1185 19.4256 14.9959 19.2981 14.9022C19.1705 14.8085 19.0226 14.7465 18.8664 14.7211C18.7102 14.6957 18.5503 14.7077 18.3996 14.7562C18.249 14.8047 18.112 14.8882 18 15L15.59 17.41C15.3967 17.6019 15.2447 17.8313 15.1432 18.0841C15.0418 18.3368 14.993 18.6077 15 18.88C15.2114 22.8214 16.8723 26.5456 19.6633 29.3366C22.4543 32.1277 26.1785 33.7885 30.12 34H30.22C30.7391 33.9899 31.234 33.7783 31.6 33.41L34 31C34.1117 30.8879 34.1952 30.7509 34.2437 30.6003C34.2922 30.4497 34.3042 30.2897 34.2789 30.1335C34.2535 29.9773 34.1914 29.8294 34.0977 29.7019C34.004 29.5744 33.8814 29.4709 33.74 29.4ZM31.56 32L30.88 32.68C30.7865 32.7726 30.6757 32.846 30.5539 32.8957C30.432 32.9455 30.3016 32.9707 30.17 32.97C26.4814 32.7713 22.9959 31.2187 20.3812 28.6095C17.7664 26.0003 16.2064 22.5181 16 18.83C16.0005 18.6977 16.0273 18.5668 16.0788 18.4449C16.1303 18.323 16.2055 18.2126 16.3 18.12L18.71 15.71L20.81 19.92L19.12 22.18C18.8783 22.4986 18.7378 22.8823 18.7164 23.2816C18.695 23.6808 18.7938 24.0774 19 24.42C20.4007 26.6887 22.3113 28.5993 24.58 30C24.8819 30.1832 25.2269 30.2833 25.58 30.29C26.0161 30.2921 26.4411 30.1517 26.79 29.89L29.05 28.2L33.26 30.3L31.56 32Z" fill="currentColor"/>
                <circle cx="25" cy="25" r="24.5" stroke="currentColor"/>
              </svg>

            </a>
          </div>
        </div>
      </div>`;

            this.list.append(this.template)
        }

        if (shops.length < 1) {
            this.clusterer.removeAll();
        }
    }

    getSchedule(schedule)
    {
        if (!!schedule.workday && !!schedule.dayoff) {
            return `Будни: ${schedule.workday}</br>Выходные: ${schedule.dayoff}`
        } else {
            return ''
        }
    }

    shopStatus(schedule)
    {
        if (!!schedule.workday && !!schedule.dayoff) {
            let dateArray = ['dayoff', 'workday', 'workday', 'workday', 'workday', 'workday', 'dayoff']
            let currentDay = dateArray[new Date().getDay()]

            let currentTimeZone = Math.abs(new Date().getTimezoneOffset() / 60);

            let shopTimeZoneOffset = schedule.timezone !== undefined ? (schedule.timezone - currentTimeZone) * 3600000 : 0

            let currentSchedule = schedule[currentDay].split('-').map(item => item.split(':'));

            currentSchedule = {
                from: new Date().setHours(currentSchedule[0][0], currentSchedule[0][1]),
                to: new Date().setHours(currentSchedule[1][0], currentSchedule[1][1])
            }

            let checkFrom = currentSchedule.from < +new Date(new Date().getTime() + shopTimeZoneOffset)
            let checkTo = currentSchedule.to > +new Date(new Date().getTime() + shopTimeZoneOffset)
            console.log(new Date(new Date().getTime() + shopTimeZoneOffset))

            if (checkFrom && checkTo) {
                return {text: 'Открыто', class: ''}
            } else {
                return {text: 'Закрыто', class: 'status-close'}
            }
        } else {
            return {text: '', class: 'd-none'}
        }
    }


    setIconPin(target, state)
    {
        let object = target.get('target');

        if (state === 'active') {
            object.options.set({iconImageHref: `${this.path}assets/images/required/map-marker-hover.svg`});

            if (object.options.get('selected')) {
                object.options.set({iconImageHref: `${this.path}assets/images/required/map-marker-selected.svg`});
            }
        } else {
            object.options.set({iconImageHref: `${this.path}assets/images/required/map-marker.svg`});

            if (object.options.get('selected')) {
                object.options.set({iconImageHref: `${this.path}assets/images/required/map-marker-selected.svg`});
            }
        }
    }

    /**
     * Определение местоположения пользователя
     * @doc https://yandex.ru/dev/maps/jsapi/doc/2.1/dg/concepts/geolocation.html
     */
    getUserLocation()
    {
        let shops = window.shops;
        let location = ymaps.geolocation;
        const that = this;

        location.get({
            // Выставляем опцию для определения положения по ip
            provider: 'yandex',
            // Карта автоматически отцентрируется по положению пользователя.
            // mapStateAutoApply: true,
            // Включим автоматическое геокодирование результата.
            autoReverseGeocode: true
        }).then(function(result) {
            // Выведем результат геокодирования.
            // that.maps.geoObjects.add(result.geoObjects);


            let address = result.geoObjects.get(0).properties.get('name');
            let userLocation = result.geoObjects.get(0).geometry.getCoordinates();
            that.searchCity.val(address);

            let locationCheck = new ymaps.Circle([userLocation, 100000], {}, {
                geodestic: true,
                opacity: 0,
            })

            that.maps.geoObjects.add(locationCheck);

            let newArray = [];

            shops.forEach((item) => {
                if (locationCheck.geometry.contains(item.coords.split(','))) {
                    newArray.push(item);
                }
            })

            that.maps.geoObjects.remove(locationCheck);

            if (address.length > 2) {
                let centerLat = 0;
                let centerLon = 0;

                for (let i = 0; i < newArray.length; i++) {
                    centerLat += parseFloat(newArray[i].coords.split(',')[0]);
                    centerLon += parseFloat(newArray[i].coords.split(',')[1]);
                }

                that.sortShopsList(that.isCity, that.isSearch, that.isSelect, newArray);
                if (that.tableCourier.length) {
                    that.courierCity = that.sortСourierList(that.isCity, that.courier);
                }

                let coords = [
                    parseFloat(centerLat / newArray.length),
                    parseFloat(centerLon / newArray.length)
                ]

                that.maps.setCenter(coords, 10, {
                    checkZoomRange: false,
                    duration: 1000,
                    timingFunction: 'ease'
                });
            }
        });
    }

    /**
     * Соритровка магазинов
     */
    sortShopsList(city, value, select, shops)
    {
        let res = [];
        let that = this;

        if (city.length > 0 && !value) {
            res = shops.filter(obj => Object.values(obj).some(val => {
                if (typeof val !== 'string') return false;
                return val.toLowerCase().includes(city.toLowerCase());
            }));
        } else {
            res = shops;
        }

        if (select.length > 0) {
            res = res.filter(obj => Object.values(obj).some(val => {
                if (typeof val !== 'string') return false;
                return val.toLowerCase().includes(select.toLowerCase())
            }));
        }

        if (value.length > 0) {
            res = res.filter(obj => Object.values(obj).some(val => {
                if (typeof val !== 'string') return false;
                return val.toLowerCase().includes(value.toLowerCase())
            }));
        }

        this.res = res;

        if (shops.length === 0) {
            this.shopsButton.trigger('click');
            this.searchCity.addClass('error');
            this.list.addClass('d-none');
            this.emptyList.removeClass('d-none');
        } else {
            this.searchCity.removeClass('error');
            this.list.removeClass('d-none');
            this.emptyList.addClass('d-none');
        }

        if (res.length > 0) {
            // Коллекция гео-объектов (отфильтрованных городов).
            // По коллекции определим центр карты и оптимальное значение масштаба.
            /** @info https://yandex.ru/dev/maps/jsbox/2.1/geo_object_collection */
            let gCollection = new ymaps.GeoObjectCollection();
            let listLat = [];
            let listLng = [];

            let centerLat = 0;
            let centerLon = 0;

            for (let i = 0; i < res.length; i++) {
                gCollection.add(
                    new ymaps.Placemark(
                        [
                            res[i].coords.split(',')[1],
                            res[i].coords.split(',')[0],
                        ]
                    )
                );

                listLat.push(res[i].coords.split(',')[0]);
                listLng.push(res[i].coords.split(',')[1]);

                centerLat += parseFloat(res[i].coords.split(',')[0]);
                centerLon += parseFloat(res[i].coords.split(',')[1]);
            }

            // Вычисляем оптимальный центр и уровень масштабирования карты
            /** @info https://yandex.ru/dev/maps/jsapi/doc/2.1/ref/reference/util.requireCenterAndZoom.html  */
            let centerAndZoom = ymaps.util.requireCenterAndZoom(
                that.maps.getType(),
                [
                    [Math.min(...listLat), Math.min(...listLng)], // Задаём минимальные и максимальные координаты объектов коллекции (городов)
                    [Math.max(...listLat), Math.max(...listLng)]
                ],
                that.maps.container.getSize()
            ).then(function(result) {
                // that.res = result.center;

                let coords = result.center;
                let zoom;
                if (result.zoom > 17) {
                    zoom = 17;
                } else if (result.zoom < 11) {
                    zoom = 11;
                } else {
                    zoom = result.zoom;
                }

                that.maps.setCenter(coords, zoom, {
                    checkZoomRange: false,
                    duration: 1000,
                    timingFunction: 'ease'
                });

            }, function(error) {

                let coords = [
                    parseFloat(centerLat / res.length),
                    parseFloat(centerLon / res.length)
                ]
                let zoom = city === '' ? 3 : 8;

                that.maps.setCenter(coords, zoom, {
                    checkZoomRange: false,
                    duration: 1000,
                    timingFunction: 'ease'
                });
            });
            this.mapDeliveryTab.removeClass('disabled');

        } else {
            this.cityCenter(value)
            this.emptyList.removeClass('d-none');
            this.shopsButton.trigger('click')

            if (this.map.is('[data-map-delivery]') && this.mapDeliveryTab.length > 0) {
                this.mapDeliveryTab.addClass('disabled');
                this.tableDelivery.find('[data-tabs-head]').children().removeClass('active');
                this.tableDelivery.find('[data-tabs-body]').children().removeClass('active');
                $(this.tableDelivery.find('[data-tabs-head]').children()[0]).addClass('active');
                $(this.tableDelivery.find('[data-tabs-body]').children()[0]).addClass('active');
            }
        }

        this.addPlacemark(res);
    }

    cityCenter(city)
    {
        this.maps.setCenter(this.cityCoords, 12, {
            checkZoomRange: false,
            duration: 1000,
            timingFunction: 'ease'
        });
    }

    zoomToShops()
    {
        let currentShops = window.shops.filter(item => item.city.toLowerCase().split(' ').includes(this.isCity.toLowerCase()));

        let centerLat = 0;
        let centerLon = 0;

        let coords = [];

        if (currentShops.length > 0) {
            for (let i = 0; i < currentShops.length; i++) {
                centerLat += parseFloat(currentShops[i].coords.split(',')[0]);
                centerLon += parseFloat(currentShops[i].coords.split(',')[1]);
            }

            coords = [
                parseFloat(centerLat / currentShops.length),
                parseFloat(centerLon / currentShops.length)
            ]

        } else {
            coords = this.userLocation;
        }

        this.maps.setCenter(coords, 10, {
            checkZoomRange: false,
            duration: 1000,
            timingFunction: 'ease'
        });
    }

    sortСourierList(value, arr)
    {
        let res = [];
        this.tableCourier.find('tbody').text('');
        this.tableOptions.text('');

        if (value.length > 0) {
            for (let i = 0; i < arr.length; i++) {
                if (value.toLowerCase() == arr[i].city.toLowerCase()) {
                    this.infoСourier(arr[i]);
                }
            }

        } else {
            res = arr;
        }

        return res;
    }

    infoСourier(arr)
    {
        let icon = 'card-red';
        let disabled = '';
        let tooltip = '';
        this.tableCourier.find('[data-table-body]').remove();

        for (let i = 0; i < arr.courier.length; i++) {
            this.templateСourier = `
      <tr class="table__tr">
        <td class="table__td d-none d-sm-table-cell">${arr.courier[i].time}</td>
        <td class="table__td">${arr.courier[i].area}</td>
        <td class="table__td">${arr.courier[i].price}</td>
      </tr>`;

            this.tableCourier.find('tbody').append(this.templateСourier);
        }

        for (let i = 0; i < arr.options.length; i++) {
            if (arr.options[i].type == '1') {
                icon = 'size-red'
            } else if (arr.options[i].type == '2') {
                icon = 'cart-red'
            } else if (arr.options[i].type == '3') {
                icon = 'pay-red'
            } else {
                icon = 'card-red'
            }

            if (arr.options[i].disabled) {
                disabled = 'card-items--disabled'
            } else {
                disabled = '';
            }

            if (arr.options[i].tooltip) {
                tooltip = `<div class="card-items__tooltip">${arr.options[i].tooltip}</div>`
            } else {
                tooltip = ''
            }

            this.templatemplateOptions = `<div class="card-items__item">
        <div class="card-items card-items--small ${disabled}">
          <div class="card-items__icon">
            <svg class="icon ${icon} red" aria-hidden="true">
              <use xlink:href="${this.path}assets/images/required/sprite.svg#${icon}"></use>
            </svg>
          </div>
          <div class="card-items__inner">
            <div class="card-items__inner-left">
              <div class="card-items__text">${arr.options[i].value}</div>
              ${tooltip}
            </div>
          </div>
        </div>
      </div>`;

            this.tableOptions.append(this.templatemplateOptions);
        }
    }
}

export {Map};

$(window).on('load', () => {
    let map = [];
    if ($('[data-map]').length > 0) {
        $('[data-map]').each(function(i) {
            map[i] = new Map($(this));
            map[i].initialize();
        });
    }
});
